import { useNavigate, Link } from "@remix-run/react";
import { CTA } from "../cta.component";

export default function Error404() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="w-full min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4 py-8 md:-mt-10 -mt-5">
      {/* Revyse Logo */}
      <div className="mb-4 sm:mb-8">
        <Link to="/" className="flex items-center">
          <img
            className="h-8 sm:h-10 w-auto"
            src="/assets/revyse-logo-color-black.png"
            alt="Revyse"
            width="320"
            height="112"
          />
        </Link>
      </div>

      {/* Lost number illustration */}
      <div className="mb-4 sm:mb-8 relative">
        <div className="text-[100px] md:text-[150px] lg:text-[180px] font-extrabold text-gray-900 leading-none tracking-tight flex items-center justify-center">
          <span className="text-coral-500">4</span>
          <div className="relative mx-1 sm:mx-2 inline-block">
            <div className="w-20 h-20 sm:w-28 sm:h-28 md:w-32 md:h-32 bg-sky-100 rounded-full flex items-center justify-center border-4 border-sky-200">
              <div className="w-14 h-14 sm:w-20 sm:h-20 md:w-24 md:h-24 bg-sky-50 rounded-full flex items-center justify-center">
                {/* Confused face */}
                <div className="relative w-12 h-6 sm:w-16 sm:h-8 md:w-20 md:h-10">
                  <div className="absolute top-0 left-2 w-2 h-2 sm:w-3 sm:h-3 bg-gray-800 rounded-full"></div>
                  <div className="absolute top-0 right-2 w-2 h-2 sm:w-3 sm:h-3 bg-gray-800 rounded-full"></div>
                  <div
                    className="absolute left-2 md:left-3 bottom-0 w-[70%] h-[2px] sm:h-1 bg-gray-800 rounded-full"
                    style={{ transform: "rotate(-10deg)" }}
                  ></div>
                </div>
              </div>
            </div>
            <div className="absolute -bottom-3 right-0 transform rotate-12">
              <span className="text-xl sm:text-2xl">?</span>
            </div>
          </div>
          <span className="text-coral-500">4</span>
        </div>
      </div>

      {/* Message */}
      <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-2 text-center text-gray-900">
        Oops! Page not found
      </h1>
      <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-6 sm:mb-8 text-center max-w-xs sm:max-w-sm md:max-w-md px-4">
        Looks like this page decided to take an unexpected vacation. Our digital
        map shows nothing but empty space where it should be.
      </p>

      {/* Navigation buttons */}
      <div className="flex flex-col md:flex-row flex-wrap gap-3 sm:gap-4 justify-center w-full max-w-xs sm:max-w-md">
        <CTA
          onClick={handleGoBack}
          variant="sky"
          fillStyle="outline"
          className="font-bold py-2 sm:py-3 px-4 sm:px-6 text-sm sm:text-base w-full md:w-auto"
        >
          Go Back
        </CTA>
        <CTA
          to="/"
          variant="coral-shadow"
          className="font-bold py-2 sm:py-3 px-4 sm:px-6 text-sm sm:text-base w-full md:w-auto"
        >
          Go Home
        </CTA>
      </div>
    </div>
  );
}
